import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios'
import { _dictionary, LanguageCode, WorkStation } from './translate'
import { AddToast } from 'react-toast-notifications'

// server call WILL execute after waiting for the specific time interval
/*export const scheduleRequests = (axiosInstance, intervalMs) => {
  let lastInvocationTime = undefined

  const scheduler = (config) => {
    const now = Date.now()
    if (lastInvocationTime) {
      lastInvocationTime += intervalMs
      const waitPeriodForThisRequest = lastInvocationTime - now
      if (waitPeriodForThisRequest > 0) {
        return new Promise((resolve) => {
          setTimeout(() => resolve(config), waitPeriodForThisRequest)
        })
      }
    }

    lastInvocationTime = now
    return config
  }

  axiosInstance.interceptors.request.use(scheduler)
}*/

// server call WILL NOT execute until waiting for the specific time interval
/*export const throttleRequests = (axiosInstance, intervalMs) => {
  let lastInvocationTime = undefined

  const scheduler = (config) => {
    const now = Date.now()
    if (lastInvocationTime) {
      lastInvocationTime += intervalMs
      const waitPeriodForThisRequest = lastInvocationTime - now
      if (waitPeriodForThisRequest > 0) {
        return new Promise((resolve) => {
          // doing nothing when function is called too frequently
        })
      }
    }

    lastInvocationTime = now
    return config
  }

  axiosInstance.interceptors.request.use(scheduler)
}*/

export class ThemeAxios {
  private _themeAxios: AxiosInstance
  constructor(
    addToast: AddToast | null = null,
    requireDataData = false,
    requireDataMeta = false,
    active_language = LanguageCode.en,
    accept_404 = false,
  ) {
    const translate = _dictionary(active_language, WorkStation.server_response)
    this._themeAxios = axios.create({ baseURL: process.env.REACT_APP_API_SERVER_URL })

    if (addToast === null) return

    this._themeAxios.interceptors.response.use(
      (response: AxiosResponse) => {
        if (!response?.data) {
          addToast(translate('An error occurred: The server failed to return data.'), {
            appearance: 'warning',
            autoDismiss: true,
          })
          return Promise.reject(new Error('Missing HTTP Response Data Data!'))
        } else if (requireDataData && !response?.data?.data) {
          addToast(translate('An error occurred: The server failed to return server data.'), {
            appearance: 'warning',
            autoDismiss: true,
          })
          return Promise.reject(new Error('Missing HTTP Response Data Data!'))
        } else if (requireDataMeta && !response?.data?.meta) {
          addToast(translate('An error occurred: The server failed to return tag data.'), {
            appearance: 'warning',
            autoDismiss: true,
          })
          return Promise.reject(new Error('Missing HTTP Response Data Meta!'))
        }

        return response.data || response
      },
      (error: AxiosError | any) => {
        if (error.response) {
          if (error.response.status === 401) {
            // the request is not authorized
            addToast(
              translate(
                'User credentials have expired and user information could not be loaded. Please log in again.',
              ),
              {
                appearance: 'warning',
                autoDismiss: true,
              },
            )
          } else if (error.response.status === 404) {
            if (!accept_404) {
              // the request path is not found
              addToast(
                translate(
                  'An error occurred, no information was found, please return to the previous page.',
                ),
                {
                  appearance: 'warning',
                  autoDismiss: true,
                },
              )
            }
          } else if (error.response.data.error && error.response.data.error.message) {
            const errorMessage =
              translate('An error occurred: ') + translate(error.response.data.error.message)
            addToast(errorMessage, {
              appearance: 'warning',
              autoDismiss: true,
            })
          }
        } else if (!error.status) {
          // the response is without status code error
          if (error.message && error.message !== 'Network Error') {
            addToast(translate('An error occurred: ') + translate(error.message) + '\n', {
              appearance: 'warning',
              autoDismiss: true,
            })
          } else {
            // network error
            addToast(translate('Unable to connect to server.'), {
              appearance: 'warning',
              autoDismiss: true,
            })
          }
        }
        return Promise.reject(error)
      },
    )
  }

  getAxios() {
    return this._themeAxios
  }
}

export const loadAxiosConfig = (jwt: string, activeBusinessEntityId: string | number = 0) => {
  return jwt
    ? {
        headers: {
          Authorization: `Bearer ${jwt}`,
          ...(activeBusinessEntityId ? { 'Active-Business-Entity': activeBusinessEntityId } : {}),
        },
      }
    : {}
}
